import React, {FC, useMemo} from 'react';
import {useBreakpoint} from "@brg/ui";
import {LayoutConst} from "../../../core";
import styled from "styled-components";

const IconWrapper = styled.div`
    transform: rotate(90deg);
`

export const MoreIcon: FC = () => {

    const is1440BP = useBreakpoint(LayoutConst.screen.mac13);
    const smHeight = useMemo(() => (window.innerHeight < LayoutConst.screen.height.projectCover), []);

    if (!is1440BP && !smHeight) return <IconWrapper><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M23.9545 14C25.0842 14 26 14.8954 26 16C26 17.1046 25.0842 18 23.9545 18C22.8247 18 21.9089 17.1046 21.9089 16C21.9089 14.8954 22.8247 14 23.9545 14Z" fill="#909090"/>
        <path d="M16.004 14C17.1337 14 18.0495 14.8954 18.0495 16C18.0495 17.1046 17.1337 18 16.004 18C14.8743 18 13.9584 17.1046 13.9584 16C13.9584 14.8954 14.8743 14 16.004 14Z" fill="#909090"/>
        <path d="M8.04555 14C9.17527 14 10.0911 14.8954 10.0911 16C10.0911 17.1046 9.17527 18 8.04555 18C6.91582 18 6 17.1046 6 16C6 14.8954 6.91582 14 8.04555 14Z" fill="#909090"/>
    </svg></IconWrapper>

    return (
        <IconWrapper><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.9545 10C21.0842 10 22 10.8954 22 12C22 13.1046 21.0842 14 19.9545 14C18.8247 14 17.9089 13.1046 17.9089 12C17.9089 10.8954 18.8247 10 19.9545 10Z" fill="#909090"/>
            <path d="M12.004 10C13.1337 10 14.0495 10.8954 14.0495 12C14.0495 13.1046 13.1337 14 12.004 14C10.8743 14 9.95845 13.1046 9.95845 12C9.95845 10.8954 10.8743 10 12.004 10Z" fill="#909090"/>
            <path d="M4.04555 10C5.17527 10 6.09109 10.8954 6.09109 12C6.09109 13.1046 5.17527 14 4.04555 14C2.91582 14 2 13.1046 2 12C2 10.8954 2.91582 10 4.04555 10Z" fill="#909090"/>
        </svg></IconWrapper>
    )
}

import React, {FC, useMemo} from 'react';
import {useBreakpoint} from "@brg/ui";
import {LayoutConst} from "../../../core";
import styled from "styled-components";

const IconWrapper = styled.div`
    transform: rotate(90deg);
`

export const MoreIcon: FC = () => {

    const is1440BP = useBreakpoint(LayoutConst.screen.mac13);
    const smHeight = useMemo(() => (window.innerHeight < LayoutConst.screen.height.projectCover), []);

    if (!is1440BP && !smHeight) return <IconWrapper><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M23.9545 14C25.0842 14 26 14.8954 26 16C26 17.1046 25.0842 18 23.9545 18C22.8247 18 21.9089 17.1046 21.9089 16C21.9089 14.8954 22.8247 14 23.9545 14Z" fill="#909090"/>
        <path d="M16.004 14C17.1337 14 18.0495 14.8954 18.0495 16C18.0495 17.1046 17.1337 18 16.004 18C14.8743 18 13.9584 17.1046 13.9584 16C13.9584 14.8954 14.8743 14 16.004 14Z" fill="#909090"/>
        <path d="M8.04555 14C9.17527 14 10.0911 14.8954 10.0911 16C10.0911 17.1046 9.17527 18 8.04555 18C6.91582 18 6 17.1046 6 16C6 14.8954 6.91582 14 8.04555 14Z" fill="#909090"/>
    </svg></IconWrapper>

    return (
        <IconWrapper><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.9545 10C21.0842 10 22 10.8954 22 12C22 13.1046 21.0842 14 19.9545 14C18.8247 14 17.9089 13.1046 17.9089 12C17.9089 10.8954 18.8247 10 19.9545 10Z" fill="#909090"/>
            <path d="M12.004 10C13.1337 10 14.0495 10.8954 14.0495 12C14.0495 13.1046 13.1337 14 12.004 14C10.8743 14 9.95845 13.1046 9.95845 12C9.95845 10.8954 10.8743 10 12.004 10Z" fill="#909090"/>
            <path d="M4.04555 10C5.17527 10 6.09109 10.8954 6.09109 12C6.09109 13.1046 5.17527 14 4.04555 14C2.91582 14 2 13.1046 2 12C2 10.8954 2.91582 10 4.04555 10Z" fill="#909090"/>
        </svg></IconWrapper>
    )
}

